module.exports = __webpack_public_path__ + "static/media/ic-collections.fea3ac8a.svg";